var _excluded = ["xlinkHref", "size", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import classNamesMaker from "classnames";
import styles from "./Illustration.module.css";
export var ILLUSTRATION_SIZES = {
  SMALL: "small",
  BIG: "big"
};
export var Illustration = function Illustration(_ref) {
  var xlinkHref = _ref.xlinkHref,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? ILLUSTRATION_SIZES.BIG : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var customClassNames = classNamesMaker(styles["jds-Illustration"], styles["jds-Illustration--".concat(size)], className);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: customClassNames,
    "aria-hidden": "true"
  }, restProps), /*#__PURE__*/React.createElement("use", {
    xlinkHref: xlinkHref
  }));
};